import axios from 'axios';
import {
  CaseTechnicalInspectionModel,
  FinalReportOfSupervisingEngineerModel,
  WrittenStatementModel
} from 'app/edozvola/cases/case-technical-inspection/model/case-technical-inspection.model';
import { FileWrapper } from 'app/shared/model/shared.model';

export const fetchFinalReports = async ({ signal, pagination, uuid }): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/technical-inspection/final-report/find-all/${uuid}?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const saveFinalReport = async (uuid: string, finalReport: FinalReportOfSupervisingEngineerModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', finalReport.multipartFile);
    formData.append('dto', new Blob([JSON.stringify(finalReport)], { type: 'application/json' })); // Attach JSON as a Blob

    axios
      .post(`api/technical-inspection/final-report/${uuid}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const getFinalReport = async (idFinalReport: string): Promise<FinalReportOfSupervisingEngineerModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/technical-inspection/final-report/${idFinalReport}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getFinalReportFile = async (idFinalReport): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/technical-inspection/final-report/${idFinalReport}/preview-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteFinalReport = async (idFinalReport) => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/technical-inspection/final-report/${idFinalReport}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
}

export const fetchWrittenStatements = async ({ signal, pagination, uuid }): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/technical-inspection/written-statement/find-all/${uuid}?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const saveWrittenStatement = async (uuid: string, writtenStatement: WrittenStatementModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', writtenStatement.multipartFile);
    formData.append('dto', new Blob([JSON.stringify(writtenStatement)], { type: 'application/json' })); // Attach JSON as a Blob

    axios
      .post(`api/technical-inspection/written-statement/${uuid}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const getWrittenStatement = async (idWrittenStatement: string): Promise<WrittenStatementModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/technical-inspection/written-statement/${idWrittenStatement}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getWrittenStatementFile = async (idWrittenStatement): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/technical-inspection/written-statement/${idWrittenStatement}/preview-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteWrittenStatement = async (idWrittenStatement) => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/technical-inspection/written-statement/${idWrittenStatement}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
}

export const getTechnicalInspection = async (uuid: string): Promise<CaseTechnicalInspectionModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/technical-inspection/${uuid}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  })
}

export const saveTechnicalInspection = async (uuid: string, technicalInspection: CaseTechnicalInspectionModel) => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/technical-inspection/${uuid}`, technicalInspection)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  })
}

export const fetchReportsAndStatements = async (uuid: string, buildingDiaryCode: string): Promise<void> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/technical-inspection/${uuid}/fetch-from-building-diary/${buildingDiaryCode}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const existsReportsOrStatementsByBuildingDiaryCode = async (uuid: string, buildingDiaryCode: string): Promise<boolean> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/technical-inspection/${uuid}/reports-exists/${buildingDiaryCode}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
